import { Link } from "react-router-dom";

import { GetServicios } from "../../actions/servicio";
import style from "../../styles/grid.module.css";
import { GotoLogin } from "../../actions/renovarLog";
import { Pencil, NotepadText , CirclePlus } from "lucide-react";
import { formatos } from "../../actions/formats.jsx";


export default function Servicio() {
   const { formatoNumero } = formatos();
   const servicios = GetServicios();
   if (servicios?.message === "Token inválido") {
      return <GotoLogin />;
   }
   return (
      <>
         <div className={style.tableCli}>
            <div className={style.header}>
               <div className={style.gridTitle}>
                  <h2>Servicios</h2>
               </div>
               <div>
                  <Link
                     to={"/formServicio"}
                     className="dLink"
                     title="Alta Servicio"
                     state={{
                        id_primary: 0,
                        id: 0,
                        companyId: 0,
                        descripcion: "",
                        stock: 0,
                        precio: 0,
                        tipo:1,
                        cod_status: 1,
                     }}
                  >
                     {" "}
                     <CirclePlus className="lucidePlus" />
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
            <div>
               <table style={{ width: "56%" }}>
                  <thead>
                     <tr className={style.trTitle}>
                        {/* <th className={style.title}>ID</th> */}
                        <th className={style.title}>Descripcion</th>
                        <th className={style.title2}>Precio</th>
                        <th>Acciones</th>
                     </tr>
                  </thead>
                  <tbody>
                     {servicios &&
                        servicios.map((serv) => {
                           return (
                              <tr key={serv.id}  className={style.trGrid} >
                                 {/* <td className={style.style_td}>{serv.id}</td> */}
                                 <td className={style.style_td}>&nbsp;
                                    {serv.descripcion}
                                 </td>
                                 <td className={style.precio}>$ {formatoNumero(serv.precio)}</td>
                                 <td className={style.tdaccions}>
                                    <Link
                                       to={"/formServicio"}
                                       className="dLink"
                                       title="Editar Servicio"
                                       state={{
                                          id_primary: serv.id_primary,
                                          id: serv.id,
                                          companyId: serv.companyId,
                                          descripcion: serv.descripcion,
                                          precio: serv.precio,
                                          tipo:serv.tipo,
                                          cod_status: serv.cod_status,
                                       }}
                                    >
                                         <Pencil className="lucideIcon" />
                                    </Link>
                                    &nbsp;&nbsp;&nbsp;
                                       <Link
                                       title="Editar Insumos"
                                       to={"/formServIns"}
                                       className="dLink"
                                       state={{
                                          id_primary: serv.id_primary,
                                          id: serv.id_primary,
                                          desc: serv.descripcion,
                                          tipo: serv.tipo
                                       }}
                                       >
                                       <NotepadText className="lucideIcon"  />
                                       {/* <button className={style.inputBtnServ}>Editar Insumos</button> */}
                                    </Link>
                                    &nbsp;&nbsp;
                                 </td>
                              </tr>
                           );
                        })}
                  </tbody>
               </table>
            </div>
         </div>
      </>
   );
}
